import { useDocumentMeta } from '../document-meta.js';
import { useLocale } from '../locale.js';

/**
 * The offline page (issue #376).
 *
 * Shown when the browser reports no network connection, and available as the
 * `/offline` route. It is imported eagerly in `app.tsx` rather than lazily with
 * the other routes: a page whose job is to render when the network is gone must
 * not itself depend on a code-split chunk that has to be fetched over that
 * network. An offline page that fails to load offline is the exact failure it
 * exists to prevent.
 */
export function Offline() {
  const { t } = useLocale();
  useDocumentMeta(t.meta.offline);
  return (
    <article className="error-page error-page--offline" role="alert">
      <h1 className="page-title">{t.errors.offline}</h1>
      <p className="page-lead">{t.errors.offlineBody}</p>
      <div className="error-page__actions">
        <button
          type="button"
          className="rp-button rp-button--primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t.errors.retry}
        </button>
        <a className="rp-button rp-button--secondary" href="/">
          {t.brand.product}
        </a>
      </div>
    </article>
  );
}
